import { TUrl } from "../../types";
import { fetchJson } from "../../fetch-json";

export interface SocialShareAnalyticsEventPayload {
  eventName?: string | null;
  nonprofitId?: number | null;
  storeId?: number | null;
  transactionId?: number | null;
  timestamp?: number | null;
}

export async function postSocialShareAnalyticsEvent({
  baseUrl,
  apiKey,
  requestBody,
}: {
  baseUrl: TUrl;
  apiKey: string;
  requestBody: SocialShareAnalyticsEventPayload;
}): Promise<void> {
  try {
    const url = baseUrl + "/api/v4/events/socialShare";
    const body = JSON.stringify(requestBody);
    await fetchJson(url, {
      method: "POST",
      body,
      headers: { authorization: `Api-Key ${apiKey}` },
    });
  } catch (error: any) {
    console.error(error);
  }
}
